// UserProvider.js
import React, { useCallback } from 'react';
import UserService from '../services/UserService';
import { catchError } from '../services/DaoService';
import PropTypes from 'prop-types';
import UserContext from '../contexts/UserContext';

export const UserProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = React.useState(null);
    const [loadingCurrentUser, setLoadingCurrentUser] = React.useState(true);

    const getCurrentUser = useCallback(() => {
        UserService.getInstance()
            .getCurrentUser()
            .then((response) => {
                setCurrentUser(response.data);
            })
            .catch(err => {
                catchError(err);
            })
            .finally(() => setLoadingCurrentUser(false));
    }, []);

    const check = useCallback((permission) => {
        if (currentUser && currentUser.permissions) {
            return currentUser.permissions.includes(permission) || currentUser.is_admin;
        }
        return false;
    }, [currentUser]);

    return (
        <UserContext.Provider value={{ currentUser, setCurrentUser, getCurrentUser, check, loadingCurrentUser }}>
            {children}
        </UserContext.Provider>
    );
};

UserProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
